module.exports = __webpack_public_path__ + "static/ebr-10-51fa7a770b6875059347a8c5b117556a.jpg";